export default "__VITE_ASSET__CdpTxtw6__"